import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Transition as _Transition, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4040be9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column","height":"100vh"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-bottom":"50px","width":"300px"},
  src: "https://klleon-media-dev.s3.amazonaws.com/media/public/klleon_saas__previewer/image/720/image-0143ae5c-3125-4399-aa4d-b0b8592bd54c.png"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Authentication ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      style: {"max-width":"500px","width":"100%"},
      model: _ctx.formState,
      onFinish: _ctx.submit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, _mergeProps(_ctx.layout, {
          label: "email",
          name: "email",
          rules: [{ required: true, message: 'Put email.' }]
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: _ctx.isSignUp ? 18 : 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.email,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.email) = $event)),
                      type: "email",
                      disabled: _ctx.isCompleteAuth
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_UserOutlined, { class: "site-form-item-icon" })
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["span"]),
                (_ctx.isSignUp)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 0,
                      span: 6,
                      style: {"justify-content":"end","display":"flex"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          disabled: _ctx.isCompleteAuth || _ctx.isValidEmail,
                          loading: _ctx.isLoadingEmail,
                          onClick: _ctx.authEmail
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }, 8, ["disabled", "loading", "onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["rules"]),
        _createVNode(_Transition, { name: "bounce" }, {
          default: _withCtx(() => [
            (_ctx.isSendEmail && _ctx.isSignUp)
              ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({ key: 0 }, _ctx.layout, {
                  label: "Authentication number",
                  name: "code",
                  rules: [{ required: true, message: 'Put the Authentication number.' }]
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: _ctx.isSignUp ? 18 : 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formState.code,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.code) = $event)),
                              "max-length": 6,
                              disabled: _ctx.isCompleteAuth
                            }, {
                              prefix: _withCtx(() => [
                                _createVNode(_component_UserOutlined, { class: "site-form-item-icon" })
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }, 8, ["span"]),
                        (_ctx.isSignUp)
                          ? (_openBlock(), _createBlock(_component_a_col, {
                              key: 0,
                              span: 6,
                              style: {"justify-content":"end","display":"flex"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  disabled: _ctx.isCompleteAuth || _ctx.isValidEmail,
                                  onClick: _ctx.authCode
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16, ["rules"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "bounce" }, {
          default: _withCtx(() => [
            (_ctx.isSignUp)
              ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({ key: 0 }, _ctx.layout, {
                  label: "Name",
                  name: "name",
                  rules: [{ required: true, message: 'Put the name' }]
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.name,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.name) = $event))
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_LockOutlined, { class: "site-form-item-icon" })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 16))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, _mergeProps(_ctx.layout, {
          label: "Password",
          name: "password",
          rules: [{ required: true, message: 'Put the password.' }]
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: _ctx.formState.password,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.password) = $event))
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_LockOutlined, { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 16, ["rules"]),
        _createVNode(_Transition, { name: "bounce" }, {
          default: _withCtx(() => [
            (_ctx.isSignUp)
              ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({ key: 0 }, _ctx.layout, {
                  label: "Password confirm",
                  name: "password2",
                  rules: [{ required: true, message: 'Put the password.' }]
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: _ctx.formState.password2,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.password2) = $event))
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_LockOutlined, { class: "site-form-item-icon" })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 16, ["rules"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isSignUp ? 'Sign-Up' : 'Sign-In'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              style: {"width":"100%"},
              onClick: _cache[5] || (_cache[5] = 
            () => {
              _ctx.isSignUp = !_ctx.isSignUp;
              _ctx.isLoadingEmail = false;
              _ctx.isSendEmail = false;
              _ctx.isLoadingCode = false;
              _ctx.isCompleteAuth = false;
            }
          )
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isSignUp ? 'Sign-In' : 'Sign-Up'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "onFinish"])
  ]))
}